module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.b257b49d.png";